import { buildCountriesTrackingValue } from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-filters/helpers";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";
import CountryService from "app/services/CountryService";
import type {
    SignalCountriesFilterProps,
} from "../../components/filters/SignalMultiselectCountriesFilter/SignalMultiselectCountriesFilter";
import SignalMultiselectCountriesFilter from "../../components/filters/SignalMultiselectCountriesFilter/SignalMultiselectCountriesFilter";

type Props = SignalCountriesFilterProps & {
    signalAlias: string;
};

const SignalMultiselectCountriesFilterTracked = (props: Props) => {
    const handleTrackedChange = (updatedValues: ReadonlyArray<number>) => {
        const trackingValue = buildCountriesTrackingValue(updatedValues, CountryService);

        trackingService.filters.trackCountriesFilterChange(trackingValue, props.signalAlias, "specific countries");
        props.onValueChange(updatedValues);
    };

    return (
        <SignalMultiselectCountriesFilter
            {...props}
            onValueChange={handleTrackedChange}
        />
    );
};

export default SignalMultiselectCountriesFilterTracked;
